var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _ellipse3, _circle11, _path10, _path11, _path12, _path13, _ellipse4, _circle12, _ellipse5, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _ellipse6, _circle20, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg130(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 447.764,
    cy: 303.862,
    rx: 257.236,
    ry: 241.925,
    fill: "#0C727E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M570.48 338.241c-1.749 6.528-6.617 12.074-14.291 16.447-7.683 4.379-18.044 7.495-30.431 9.169-24.764 3.346-57.217.874-91.446-8.298-34.229-9.171-63.57-23.257-83.343-38.537-9.89-7.643-17.305-15.522-21.77-23.155-4.46-7.625-5.902-14.862-4.153-21.39 1.749-6.527 6.617-12.073 14.291-16.447 7.684-4.378 18.045-7.495 30.431-9.168 24.764-3.347 57.217-.874 91.446 8.298 34.229 9.171 63.571 23.256 83.344 38.536 9.89 7.643 17.305 15.522 21.769 23.156 4.46 7.625 5.902 14.862 4.153 21.389z",
    stroke: "#fff",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M639.855 355.333c-7.8 29.11-35.977 50.229-76.057 60.477-40.01 10.23-91.433 9.475-144.743-4.81-53.309-14.284-98.221-39.341-127.755-68.206-29.586-28.914-43.429-61.293-35.629-90.403 7.8-29.111 35.977-50.23 76.057-60.478 40.01-10.23 91.433-9.474 144.743 4.81 53.309 14.284 98.221 39.342 127.755 68.206 29.586 28.915 43.429 61.293 35.629 90.404z",
    stroke: "#fff",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M699.228 363.447c-11.641 43.446-49.838 75.661-102.735 92.397-52.872 16.729-120.154 17.877-189.277-.644-69.123-18.521-126.817-53.157-164.241-94.08-37.442-40.943-54.414-87.941-42.773-131.386 11.641-43.446 49.838-75.661 102.735-92.397 52.872-16.729 120.155-17.877 189.277.644 69.123 18.522 126.817 53.158 164.241 94.081 37.442 40.943 54.415 87.94 42.773 131.385z",
    stroke: "#fff",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M501.553 225.083c43.612 29.779 54.875 89.189 25.17 132.694-29.706 43.504-89.139 54.642-132.752 24.863-43.612-29.779-54.875-89.189-25.17-132.694 29.706-43.505 89.14-54.642 132.752-24.863z",
    stroke: "#fff",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M741.935 536.662s-42.986-34.046-71.313-37.949c-28.027-3.861-101.908.665-156.73-22.574a2.39 2.39 0 0 1-1.422-2.697c.871-3.969 4.984-12.419 24.749-11.599 25.727 1.111 45.445 1.451 45.445 1.451s-79.032-78.119-98.874-100.88c-3.919-4.491-6.568-8.543-8.296-12.226-5.382-11.488 9.382-21.807 18.528-13.01l53.536 51.456s-2.532-8.065 3.123-13.069c5.36-4.721 18.936-2.119 26.863 6.429 0 0-2.079-9.294 6.858-13.413 8.936-4.118 20.677 2.998 25.659 7.615 0 0-3.906-8.435 1.674-13.255 5.58-4.821 20.376-.124 24.345 2.712 3.969 2.836 41.023 20.574 81.17 70.281l78.659 24.364s11.009 29.109-53.974 76.364zM157.467 64.17s42.987 34.046 71.313 37.95c28.027 3.86 101.908-.666 156.73 22.573a2.389 2.389 0 0 1 1.422 2.698c-.87 3.969-4.984 12.419-24.749 11.598-25.726-1.111-45.445-1.451-45.445-1.451s79.032 78.12 98.874 100.88c3.919 4.492 6.569 8.544 8.296 12.227 5.383 11.488-9.381 21.806-18.528 13.01l-53.535-51.456s2.531 8.065-3.123 13.069c-5.36 4.72-18.936 2.118-26.864-6.43 0 0 2.079 9.295-6.857 13.413-8.937 4.119-20.678-2.997-25.659-7.615 0 0 3.906 8.436-1.674 13.256s-20.376.123-24.346-2.713c-3.969-2.836-41.022-20.574-81.169-70.281l-78.66-24.364s-11.01-29.109 53.974-76.363z",
    fill: "#F8AE9D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M447.777 266h.436C450.795 300.295 478 300.823 478 300.823s-30 .549-30 40.177c0-39.628-30-40.177-30-40.177s27.195-.528 29.777-34.823z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M722.805 372.217c10.436 7.187 26.378 2.163 26.378 2.163s-.987-16.677-11.429-23.857c-10.436-7.188-26.371-2.171-26.371-2.171s.987 16.677 11.422 23.865z",
    fill: "url(#a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.218 313.028c10.81 11.002 31.024 8.682 31.024 8.682s2.675-20.158-8.145-31.153c-10.81-11.002-31.014-8.689-31.014-8.689s-2.675 20.158 8.135 31.16z",
    fill: "url(#b)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 480.139,
    cy: 527.394,
    rx: 17.139,
    ry: 16.394,
    transform: "rotate(180 480.139 527.394)",
    fill: "#0C727E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 387.298,
    r: 10,
    transform: "rotate(180 168 387.298)",
    fill: "#0C727E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 9.5,
    transform: "matrix(-1 0 0 1 343.5 52.5)",
    fill: "#0C727E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 15.648,
    transform: "matrix(-1 0 0 1 660.648 203.648)",
    fill: "#0C727E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 9.802,
    transform: "matrix(-1 0 0 1 612.802 533.802)",
    fill: "#E1E4E5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 18,
    transform: "matrix(-1 0 0 1 309 500)",
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 6,
    transform: "matrix(-1 0 0 1 472 496)",
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 7.294,
    transform: "matrix(-1 0 0 1 703.294 253.294)",
    fill: "#E1E4E5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 11.133,
    transform: "matrix(-1 0 0 1 634.133 139.132)",
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 5.631,
    transform: "matrix(0 1 1 0 236.631 298.631)",
    fill: "#E1E4E5"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 6.922,
    transform: "matrix(-1 0 0 1 160.922 180.922)",
    fill: "#E1E4E5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.452,
    ry: 5.961,
    transform: "matrix(-1 0 0 1 737.452 416.961)",
    fill: "#E1E4E5"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 10.5,
    transform: "matrix(0 1 1 0 479.5 114.5)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M709.313 179h.195c1.154 16.356 13.318 16.607 13.318 16.607s-13.413.262-13.413 19.161c0-18.899-13.413-19.161-13.413-19.161s12.158-.251 13.313-16.607zM279.422 62h.152C280.478 75.26 290 75.465 290 75.465s-10.5.212-10.5 15.535c0-15.323-10.5-15.535-10.5-15.535s9.518-.204 10.422-13.465z",
    fill: "#E1E4E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M266.834 418.247c4.905-1.162 10.092 2.998 10.092 2.998s-2.768 6.04-7.674 7.199c-4.905 1.162-10.09-2.994-10.09-2.994s2.768-6.041 7.672-7.203z",
    fill: "url(#c)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M289.798 310.199c-4.347-2.994-10.988-.901-10.988-.901s.411 6.947 4.761 9.938c4.347 2.994 10.985.904 10.985.904s-.411-6.947-4.758-9.941z",
    fill: "url(#d)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M602.826 294.572c-6.566-6.682-18.843-5.273-18.843-5.273s-1.625 12.243 4.947 18.921c6.565 6.683 18.837 5.278 18.837 5.278s1.625-12.243-4.941-18.926z",
    fill: "url(#e)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.677,
    cy: 271.283,
    rx: 12.685,
    ry: 12.109,
    fill: "#0C727E"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 702.685,
    cy: 133.685,
    r: 12.685,
    fill: "#0C727E"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.532,
    ry: 12.109,
    transform: "matrix(1 0 0 -1 230.532 481.109)",
    fill: "#0C727E"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    r: 9.802,
    transform: "matrix(1 0 0 -1 734.802 298.802)",
    fill: "#0C727E"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    r: 5.862,
    transform: "matrix(1 0 0 -1 384.652 168.167)",
    fill: "#fff"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    r: 6.166,
    transform: "matrix(1 0 0 -1 579.85 128.108)",
    fill: "#fff"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    r: 3.038,
    transform: "matrix(1 0 0 -1 325.825 347.651)",
    fill: "#E1E4E5"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    r: 4.637,
    transform: "matrix(1 0 0 -1 390.637 515.637)",
    fill: "#fff"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    r: 6.132,
    transform: "matrix(0 -1 -1 0 565.132 261.132)",
    fill: "#E1E4E5"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    r: 6.343,
    transform: "matrix(1 0 0 -1 661.343 307.343)",
    fill: "#E1E4E5"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.956,
    ry: 8.649,
    transform: "matrix(1 0 0 -1 183.319 236.687)",
    fill: "#E1E4E5"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    r: 6.313,
    transform: "scale(-1 1) rotate(-75 123.96 465.469)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M312.918 387.089h-.081c-.481-6.813-5.547-6.918-5.547-6.918s5.587-.109 5.587-7.981c0 7.872 5.587 7.981 5.587 7.981s-5.065.105-5.546 6.918zm182.833 35.641h-.096c-.564-8.151-6.507-8.277-6.507-8.277s6.554-.13 6.554-9.549c0 9.419 6.553 9.549 6.553 9.549s-5.94.126-6.504 8.277z",
    fill: "#E1E4E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 763.456,
    y1: 395.801,
    x2: 681.311,
    y2: 309.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 189.347,
    y1: 350.608,
    x2: 111.199,
    y2: 228.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 285.303,
    y1: 415.358,
    x2: 242.37,
    y2: 435.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 272.865,
    y1: 300.375,
    x2: 307.083,
    y2: 336.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 576.63,
    y1: 271.747,
    x2: 624.096,
    y2: 346.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg130);
export default __webpack_public_path__ + "static/media/130.edb92a40384286c99c89f09831c23725.svg";
export { ForwardRef as ReactComponent };